export default __webpack_public_path__ + "static/media/carousel-1-lexmark.4a07b184.jpg";